var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"row c_center"},[(_vm.showTitle)?_c('h1',{staticClass:"title"},[_vm._v("平台服务使用协议")]):_vm._e()]),_c('iframe',{attrs:{"src":_vm.iframeSrc,"frameborder":"0"}})])}
var staticRenderFns = []

export { render, staticRenderFns }